export const RESPONSIVE = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
      yAxes: [{
          ticks: {
              beginAtZero: true,
              callback: function (value) {
                  if (value % 1 === 0) {
                      return value;
                  }
              }
          }
      }]
  },
}


// WEBPACK FOOTER //
// ./src/constants/chart.js